import React from "react";
import styled from "styled-components";
import { vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";

export type PillsSectionProps = {
  isPublished?: boolean;
  title: string;
  background_color: string;
  text_color: string;
  pill_background_color: string;
  pill_text_color: string;
  pills: {
    text: string;
  }[];
};

export default function PillsSection(
  props: PillsSectionProps,
): JSX.Element | null {
  return (
    <Container
      backgroundColor={props?.background_color ?? "#FDC04E"}
    >
      <Title textColor={props?.text_color ?? "#13320C"}>
        {props?.title}
      </Title>
      <Pills>
        {props?.pills?.map((pill) => (
          <Pill
            key={pill.text}
            backgroundColor={
              props?.pill_background_color ?? "var(--color-white)"
            }
            textColor={props?.pill_text_color ?? "#13320C"}
            dangerouslySetInnerHTML={{
              __html: pill.text,
            }}
          />
        ))}
      </Pills>
    </Container>
  );
}

const Container = styled.section<{
  backgroundColor?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${vwMobile(27)};
  padding: ${vwMobile(47)} ${vwMobile(30)};
  background-color: ${(props) => props.backgroundColor};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  color: var(--color-white);

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${vwDesktop(27)};
    padding: ${vwDesktop(47)} 0 ${vwDesktop(90)};
  }
`;

const Title = styled.p<{
  textColor?: string;
}>`
  font-size: ${vwMobile(40)};
  line-height: 0.92;
  letter-spacing: 0.03em;
  font-weight: 900;
  text-align: center;
  color: ${(props) => props.textColor};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${vwDesktop(59)};
  }
`;

const Pills = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${vwMobile(12)};
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-inline: auto;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${vwDesktop(20)};
    max-width: ${vwDesktop(1000)};
  }
`;

const Pill = styled.div<{
  backgroundColor?: string;
  textColor?: string;
}>`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  padding: ${vwMobile(16)} ${vwMobile(34)};
  border-radius: ${vwMobile(50)};
  font-size: ${vwMobile(18)};
  font-weight: 900;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.04;
  letter-spacing: 0.077px;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${vwDesktop(16)};
    min-height: ${vwDesktop(106)};
    padding: ${vwDesktop(16)} ${vwDesktop(50)};
    border-radius: ${vwDesktop(80)};
    font-size: ${vwDesktop(23)};
  }
`;
